module.exports = {
  __init__: [ 'overlays' ],
  overlays: [ 'type', require('./Overlays') ]
};


// WEBPACK FOOTER //
// ./~/diagram-js/lib/features/overlays/index.js